"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.$supplProvision = exports.supplProvisionToLines = void 0;
const factory_1 = require("../factory");
const line_1 = require("../../../node/cst/line");
const util_1 = require("../util");
const std_1 = require("../../../law/std");
const std = __importStar(require("../../../law/std"));
const toCSTSettings_1 = __importDefault(require("../toCSTSettings"));
const _paragraphItem_1 = __importStar(require("./$paragraphItem"));
const util_2 = require("../../../util");
const _sentenceChildren_1 = require("../../cst/rules/$sentenceChildren");
const _article_1 = __importStar(require("./$article"));
const _articleGroup_1 = __importStar(require("./$articleGroup"));
const _supplProvisionAppdxItem_1 = require("./$supplProvisionAppdxItem");
const inline_1 = require("../../../node/cst/inline");
const _supplProvisionHeadLine_1 = require("../../cst/rules/$supplProvisionHeadLine");
const el_1 = require("../../../node/el");
/**
 * The renderer for {@link std.SupplProvision}. Please see the source code for the detailed syntax, and the [test code](https://github.com/yamachig/Lawtext/blob/main/core/src/parser/std/rules/$supplProvision.spec.ts) for examples.
 */
const supplProvisionToLines = (supplProvision, indentTexts) => {
    const lines = [];
    const supplProvisionLabel = supplProvision.children.find(el => el.tag === "SupplProvisionLabel");
    const supplProvisionLabelStr = (0, _sentenceChildren_1.sentenceChildrenToString)(supplProvisionLabel?.children ?? []);
    const controlStrs = [];
    if (indentTexts.length !== 0) {
        controlStrs.push(":keep-indents:");
    }
    if (!_supplProvisionHeadLine_1.supplProvisionLabelPtn.exec(supplProvisionLabelStr)) {
        controlStrs.push(_supplProvisionHeadLine_1.supplProvisionControl);
    }
    lines.push(new line_1.SupplProvisionHeadLine({
        range: null,
        indentTexts: [...indentTexts, toCSTSettings_1.default.INDENT, toCSTSettings_1.default.INDENT, toCSTSettings_1.default.INDENT],
        controls: controlStrs.map((str, i) => new inline_1.Control(str, null, i !== controlStrs.length - 1 ? " " : "", null)),
        title: supplProvisionLabelStr,
        titleRange: null,
        openParen: (typeof supplProvision.attr.AmendLawNum === "string") ? `${toCSTSettings_1.default.MARGIN}（` : "",
        amendLawNum: supplProvision.attr.AmendLawNum ?? "",
        closeParen: (typeof supplProvision.attr.AmendLawNum === "string") ? "）" : "",
        extractText: supplProvision.attr.Extract === "true" ? `${toCSTSettings_1.default.MARGIN}抄` : "",
        lineEndText: toCSTSettings_1.default.EOL,
    }));
    lines.push(new line_1.BlankLine({ range: null, lineEndText: toCSTSettings_1.default.EOL }));
    const paragraphs = supplProvision.children.filter(std_1.isParagraph);
    const isSingleAnonymParagraph = ((paragraphs.length === 1) &&
        paragraphs.every(p => (p.children.filter(std_1.isParagraphItemTitle).every(el => el.text() === "") &&
            (p.children.filter(c => std.isParagraphSentence(c) && c.text().length > 0).length > 0))));
    for (const child of supplProvision.children) {
        if (child.tag === "SupplProvisionLabel")
            continue;
        if ((0, std_1.isParagraphItem)(child)) {
            if (isSingleAnonymParagraph) {
                lines.push(...(0, _paragraphItem_1.paragraphItemToLines)(child, indentTexts, { noControl: true }));
            }
            else {
                lines.push(...(0, _paragraphItem_1.paragraphItemToLines)(child, indentTexts, { defaultTag: "Paragraph" }));
            }
            lines.push(new line_1.BlankLine({ range: null, lineEndText: toCSTSettings_1.default.EOL }));
        }
        else if ((0, std_1.isArticle)(child)) {
            lines.push(...(0, _article_1.articleToLines)(child, indentTexts));
            lines.push(new line_1.BlankLine({ range: null, lineEndText: toCSTSettings_1.default.EOL }));
        }
        else if ((0, std_1.isArticleGroup)(child)) {
            lines.push(...(0, _articleGroup_1.articleGroupToLines)(child, indentTexts));
            lines.push(new line_1.BlankLine({ range: null, lineEndText: toCSTSettings_1.default.EOL }));
        }
        else if ((0, std_1.isSupplProvisionAppdxItem)(child)) {
            lines.push(...(0, _supplProvisionAppdxItem_1.supplProvisionAppdxItemToLines)(child, indentTexts));
            lines.push(new line_1.BlankLine({ range: null, lineEndText: toCSTSettings_1.default.EOL }));
        }
        else {
            (0, util_2.assertNever)(child);
        }
    }
    return lines;
};
exports.supplProvisionToLines = supplProvisionToLines;
const $supplProvisionChildren = factory_1.factory
    .withName("supplProvisionChildren")
    .sequence(s => s
    .and(r => r
    .sequence(s => s
    .and(r => r
    .choice(c => c
    .or(r => r
    .oneOrMore(r => r
    .sequence(s => s
    .and(r => r
    .choice(c => c
    .or(() => _article_1.default)
    .or(() => _articleGroup_1.default)))
    .andOmit(r => r.zeroOrMore(() => util_1.$blankLine)))))
    .or(r => r
    .oneOrMore(r => r
    .sequence(s => s
    .and(r => r
    .choice(c => c
    .or(() => (0, _paragraphItem_1.default)("Paragraph"))))
    .andOmit(r => r.zeroOrMore(() => util_1.$blankLine)))))
    .or(r => r
    .sequence(s => s
    .and(r => r
    .oneOrMore(r => r
    .sequence(s => s
    .and(r => r
    .choice(c => c
    .or(() => _paragraphItem_1.$noControlAnonymParagraph)))
    .andOmit(r => r.zeroOrMore(() => util_1.$blankLine)))), "anonymParagraphs")
    .action(({ anonymParagraphs }) => {
    for (const [i, { value: paragraph }] of anonymParagraphs.entries()) {
        paragraph.attr.Num = (i + 1).toString();
    }
    return anonymParagraphs;
})))))
    .and(r => r
    .zeroOrMore(r => r
    .sequence(s => s
    .and(r => r
    .choice(c => c
    .or(() => _supplProvisionAppdxItem_1.$supplProvisionAppdx)
    .or(() => _supplProvisionAppdxItem_1.$supplProvisionAppdxStyle)
    .or(() => _supplProvisionAppdxItem_1.$supplProvisionAppdxTable)))
    .andOmit(r => r.zeroOrMore(() => util_1.$blankLine)))))), "childrenList")
    .action(({ childrenList }) => {
    const children = childrenList.flat();
    return {
        value: children.map(c => c.value).flat(),
        errors: children.map(c => c.errors).flat(),
    };
}));
/**
 * The parser rule for {@link std.SupplProvision}. Please see the source code for the detailed syntax, and the [test code](https://github.com/yamachig/Lawtext/blob/main/core/src/parser/std/rules/$supplProvision.spec.ts) for examples.
 */
exports.$supplProvision = factory_1.factory
    .withName("supplProvision")
    .sequence(s => s
    .and(r => r
    .oneMatch(({ item }) => {
    if (item.type === line_1.LineType.SPR) {
        return item;
    }
    else {
        return null;
    }
}), "labelLine")
    .and(r => r.zeroOrMore(() => util_1.$blankLine))
    .and(() => $supplProvisionChildren, "children")
    .action(({ labelLine, children }) => {
    const supplProvisionLabel = (0, std_1.newStdEL)("SupplProvisionLabel", {}, [labelLine.line.title], labelLine.virtualRange);
    const supplProvisionChildren = [
        supplProvisionLabel,
        ...children.value
    ];
    const pos = labelLine.line.indentsEndPos;
    const range = (0, el_1.rangeOfELs)(supplProvisionChildren) ?? (pos !== null ? [pos, pos] : null);
    if (range && pos !== null) {
        range[0] = pos;
    }
    const supplProvision = (0, std_1.newStdEL)("SupplProvision", {
        ...(labelLine.line.amendLawNum !== "" ? { AmendLawNum: labelLine.line.amendLawNum } : {}),
        ...(labelLine.line.extractText !== "" ? { Extract: "true" } : {}),
    }, supplProvisionChildren, range);
    return {
        value: supplProvision,
        errors: [...children.errors],
    };
}));
exports.default = exports.$supplProvision;
//# sourceMappingURL=$supplProvision.js.map